import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export type BannerInfoKey = 'KSeF' | 'Test';

export interface BannerInfoItem {
	readonly key: BannerInfoKey;
	readonly url: string;
}

export class BannerInfoQuery extends Query<BannerInfoItem[]> { }

export class BannerInfoQueryHandlerBase implements QueryHandler<BannerInfoQuery, BannerInfoItem[]> {
	private static Url = TaggedUrl.join('user/banner', [Tags.Api]);

	public constructor(private readonly http: HttpService) { }

	public async handleAsync(): Promise<BannerInfoItem[]> {
		const { data } = await this.http.get<BannerInfoItem[]>(BannerInfoQueryHandlerBase.Url);
		return data;
	}
}
